import { useMemo } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/** Renders Jira-rendered HTML (description/comment) after sanitizing it. */
export const JiraHtml = ({
    html,
    sx,
}: {
    html: string;
    sx?: SxProps<Theme>;
}) => {
    const clean = useMemo(() => DOMPurify.sanitize(html), [html]);
    return (
        <Box
            sx={[
                {
                    typography: 'body2',
                    overflowWrap: 'anywhere',
                    '& p': { m: 0, mb: 0.5 },
                    '& img': { maxWidth: '100%', height: 'auto' },
                    '& pre, & code': { whiteSpace: 'pre-wrap' },
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            dangerouslySetInnerHTML={{ __html: clean }}
        />
    );
};
